export default __webpack_public_path__ + "static/media/info.e7fa3b8d.jpg";